module.exports = __webpack_public_path__ + "static/media/logout.d038464c.svg";